module.exports = __webpack_public_path__ + "img/mlh_honor_7.a76ad392.png";